export enum ChatResponseType {
  START = 'start',
  CHUNK = 'chunk',
  END = 'end',
  ERROR = 'error',
  COMPLETE = 'complete',
  RELEVANT_BUBBLES = 'relevant_bubbles',
  FOLLOW_UP = 'follow_up',
}

export enum ChatType {
  GLOBAL = 'global',
  COLLECTION = 'collection',
  BUBBLE = 'bubble',
}
